export const agroPlotModel = {
    label: 'Parcelle (Agroforesterie)',
    tableName: 'plots',
    properties: [
        { label: 'Nom paysan', id: 'peasant_firstname', type: 'text', example: 'RAKOTO', required: true },
        { label: 'Prénom paysan', id: 'peasant_lastname', type: 'text', example: 'Jean', required: true },
        { label: 'Groupe du paysan', id: 'agroGroups', example: 'Analamanga_01', type: 'text', required: true },
        { label: 'Surface', id: 'surface', type: 'text', example: '1500', required: true },
        { label: 'Statut foncier', id: 'statut_foncier', type: 'text', example: 'Titré', required: true },
        { label: 'Waypoint', id: 'waypoint', type: 'text', example: 'WP001', required: true },
        { label: 'Toposéquence', id: 'topo', type: 'text', example: 'Sommet', required: true },
        { label: 'Texture', id: 'texture', type: 'text', example: 'Sableux', required: true },
        { label: 'Utilisation actuelle', id: 'use_actually', type: 'text', example: 'Riziculture', required: true },
        { label: 'Estimation arbres', id: 'estimated_number_plant', type: 'text', example: '45', required: true }
    ]
}
